<script setup>
import { computed, inject } from 'vue';
import { styleVars } from './shared.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

const post = inject('tiqCurrentPost', null);
// A visitor never meets the slot's placeholder: with no real post
// to render it draws nothing, and only the editor keeps the stand-in.
const editing = inject('tiqEditorCanvas', false);

// The "← All news" link lives on post_hero, not here: two of them on
// one template would be two ways back to the same page.
const title = computed(() => post?.title || 'Post title');
const align = computed(() => (['left', 'center', 'right'].includes(props.config.align) ? props.config.align : 'left'));
</script>

<template>
    <section v-if="post || editing" :id="config.anchor_id || null" class="th-block th-post-title" :style="styleVars(config)">
        <div class="th-wrap th-sec th-sec--tight">
            <h1 class="th-h1 th-h1--article th-post-title__h" :class="`th-post-title__h--${align}`">{{ title }}</h1>
        </div>
    </section>
</template>

<style scoped>
.th-post-title__h { max-width: 820px; margin: 0 auto; }
.th-post-title__h--center { text-align: center; }
.th-post-title__h--right { text-align: right; }
</style>
